import { render, staticRenderFns } from "./structure-form.vue?vue&type=template&id=02f10a00&"
import script from "./structure-form.vue?vue&type=script&lang=js&"
export * from "./structure-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports